export const STEP_DOSSIER = 'dossier'
export const STEP_COMPLETE = 'complete'
export const STEP_TRANSMISSION = 'transmission'
export const STEP_TRANSFERRED = 'transferred'
export const STEP_NET = 'net'

export const ALL_STEPS = [STEP_DOSSIER, STEP_COMPLETE, STEP_TRANSMISSION, STEP_TRANSFERRED, STEP_NET]

export const INSURANCE_TELECOM_STEPS = [STEP_DOSSIER, STEP_COMPLETE, STEP_TRANSFERRED, STEP_NET]
